<header class="relative">
    <div class="relative">
            @if(componentModel.videoUrl.value){
                <div class="absolute top-0 left-0 w-full h-full object-cover">

                </div>
                @defer{
                    <white-label-video-player
                            [autoplay]="true"
                            [isMuted]="true"
                            [loop]="true"
                            [showMuteButton] = "true"
                            [showPlayButton] = "false"
                            [videoUrl]="componentModel.videoUrl.value"
                    >
                    </white-label-video-player>
                } @placeholder{
                    <div></div>
                }
            } @else {
                <div class="relative w-full h-64 md:h-96 bg-cover" [style.background-image]="'url(' + componentModel.imageUrl.value + ')'">

                </div>
            }
        <div class="h-10 bg-gradient-to-b from-transparent to-bg_primary absolute bottom-0 w-full"></div>
    </div>
</header>
<section class="relative md:-mt-28 -mt-24 m-auto text-center">
    <div class="w-fit m-auto relative">
        <div class="rounded-2xl min-h-52 m-auto relative top-0 bg-card" >
            <div class="md:flex block min-h-52 gap-4 align-center h-full text-normal" >
                <div class="relative md:w-56 md:h-auto">
                    <app-image-wrapper  [avatar]="componentModel.imageUrl.value" [fontSize]="50" [class]="'md:rounded-2xl md:absolute md:w-full md:h-full object-center object-cover rounded-full w-48 h-48 m-auto'"></app-image-wrapper>
                </div>
                <div class="p-3">
                    <div class="hero">
                        <h2 class="text-4xl  md:text-left text-normal" data-elapsed="100">
                            {{componentModel.nickname.value}}
                        </h2>
                        <div class="mt-4">
                            @if(componentModel.location.value){
                                <div class="flex md:justify-start justify-center gap-x-4 items-center mt-3" data-elapsed="160">
                                    <div class="text-normal">
                                        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.99998 0C3.58199 0 0 3.582 0 8C0 11.467 2.248 15.412 5.281 18.688C5.379 18.793 5.459 18.875 5.562 18.969C6.421 19.738 7.31099 20.01 7.99998 20C8.00898 20 8.02399 20 8.03099 20C8.74899 20 9.76098 19.677 10.719 18.719C13.629 15.809 16 11.518 16 8C16 3.582 12.418 0 7.99998 0ZM7.99998 5C9.65698 5 11 6.343 11 8C11 9.657 9.65698 11 7.99998 11C6.34299 11 4.99999 9.657 4.99999 8C4.99999 6.343 6.34299 5 7.99998 5Z" fill="currentColor"></path>
                                        </svg>
                                    </div>
                                    <span>
                                      {{componentModel.location.value}}
                                    </span>
                                    <img loading="lazy" (error)="onImageError($event)" src="assets/langpng/{{langPath}}.png" class="h-6" [alt]= "componentModel.location.value"/>
                                </div>
                            } @else {
                                <div class="flex md:justify-start justify-center gap-x-4 items-center mt-3" data-elapsed="160">
                                    <div>
                                        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.99998 0C3.58199 0 0 3.582 0 8C0 11.467 2.248 15.412 5.281 18.688C5.379 18.793 5.459 18.875 5.562 18.969C6.421 19.738 7.31099 20.01 7.99998 20C8.00898 20 8.02399 20 8.03099 20C8.74899 20 9.76098 19.677 10.719 18.719C13.629 15.809 16 11.518 16 8C16 3.582 12.418 0 7.99998 0ZM7.99998 5C9.65698 5 11 6.343 11 8C11 9.657 9.65698 11 7.99998 11C6.34299 11 4.99999 9.657 4.99999 8C4.99999 6.343 6.34299 5 7.99998 5Z" fill="#F0F2F7"></path>
                                        </svg>
                                    </div>
                                    <span>
                                      {{'Not Defined' | translate}}
                                    </span>
                                    <img loading="lazy"  src="/assets/flags/global.svg" alt="global" class="w-6 h-6"/>
                                </div>
                            }

                            <div class="hero__divider animated-box" data-elapsed="160" ></div>

                            <div class="flex md:justify-start justify-center mt-4 gap-4 animated-box" data-elapsed="180">
                                @if(componentModel?.contact?.value?.twitter.value){
                                    <a [href]="componentModel.contact.value.twitter?.value" target="_blank">
                                        <icon-x class="text-normal h-5 hover:text-normal-hover"></icon-x>
                                    </a>
                                }
                                @if(componentModel?.contact?.value.youtube?.value){
                                    <a [href]="componentModel.contact.value.youtube?.value" target="_blank">
                                        <icon-youtube class="text-normal h-6 hover:text-normal-hover"></icon-youtube>
                                    </a>
                                }

                                @if(componentModel?.contact?.value.facebook?.value){
                                    <a [href]="componentModel.contact.value.facebook?.value" target="_blank">
                                        <icon-fb class="text-normal h-6 hover:text-normal-hover"></icon-fb>
                                    </a>
                                }
                                @if(componentModel?.contact?.value.instagram?.value){
                                    <a [href]="componentModel.contact.value.instagram?.value" target="_blank">
                                        <icon-instagram class="text-normal h-6 hover:text-normal-hover"></icon-instagram>
                                    </a>
                                }
                                @if(componentModel?.contact?.value.telegram?.value){
                                    <a [href]="componentModel.contact.value.telegram?.value" target="_blank">
                                        <icon-telegram class="text-normal h-6 hover:text-normal-hover"></icon-telegram>
                                    </a>
                                }

                                @if(componentModel?.contact?.value.tiktok?.value){
                                    <a [href]="componentModel.contact.value.tiktok.value" target="_blank">
                                        <icon-tiktok class="text-normal h-6 hover:text-normal-hover"></icon-tiktok>
                                    </a>
                                }
                                @if(componentModel?.contact?.value.discord?.value){
                                    <a [href]="componentModel.contact.value.discord.value" target="_blank">
                                        <icon-discord class="text-normal h-6 hover:text-normal-hover"></icon-discord>
                                    </a>
                                }
                                @if(componentModel?.contact?.value.twitch?.value){
                                    <a [href]="componentModel.contact.value.twitch.value" target="_blank">
                                        <icon-twitch class="text-normal h-6 hover:text-normal-hover"></icon-twitch>
                                    </a>
                                }
                            </div>

                        </div>


                        <div class="flex md:justify-between items-center justify-center gap-8 mt-3 md:text-left text-center">
                            @for (item of componentModel.stats.value; track $index){
                                <div class=" items-center animated-box">
                                    <div class="text-center">
                                        <div class="md:text-3xl text-xl">{{ item.value.value || 0 }}</div>
                                        <div class="text-xs" [style.color]="styling?.colors?.text">{{item.label.value}}</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class=" m-auto relative md:-top-2 top-0 text-center">
        <div class="isolate inline-flex md:top-2  text-center shadow-sm pt-2 md:pt-0 z-10 rounded-md">
            <white-label-button
                    class="relative rounded-l-md rounded-r-md inline-flex items-center transition-colors duration-200 text-sm font-semibold focus:z-10"
                    [link]="'/marketplace/product/' + componentModel.buttonLink.value"
                    [text]="componentModel.buttonText.value"
            ></white-label-button>
        </div>
    </div>
</section>


